import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { quickSpring } from '@/lib/animations'

interface HeaderContentProps {
  children: React.ReactNode
  isScrolled: boolean
  isCollapsed: boolean
}

export function HeaderContent({ children, isScrolled, isCollapsed }: HeaderContentProps) {
  return (
    <motion.div
      className={cn(
        'w-full transition-colors duration-200',
        isScrolled
          ? 'bg-white/95 backdrop-blur-2xl shadow-lg border-b border-black/5'
          : 'bg-white/85 backdrop-blur-xl border-b border-gray-100'
      )}
      animate={{ height: isCollapsed ? 48 : 56 }}
      transition={quickSpring}
    >
      {children}
    </motion.div>
  )
}
